import UploadIcon from '@/shared/assets/icons/upload.svg';
import CloseIcon from '@/shared/assets/icons/close.svg';
import PdfIcon from '@/shared/assets/icons/files/pdf.complex.svg';
import { Svg } from '@/shared/ui/Svg';

interface RequestFilesFieldProps {
  files: File[];
  onChange: (files: File[]) => void;
  maxFiles?: number;
}

export const MAX_REQUEST_FILES = 5;
const MAX_SIZE = 20 * 1024 * 1024;
const ACCEPT = '.png,.jpeg,.jpg,.pdf,.csv';

export const RequestFilesField = ({
  files,
  onChange,
  maxFiles = MAX_REQUEST_FILES,
}: RequestFilesFieldProps) => {
  const handleFiles = (fileList: FileList | null) => {
    if (!fileList) return;

    const incoming = Array.from(fileList).filter((file) => file.size <= MAX_SIZE);
    onChange([...files, ...incoming].slice(0, maxFiles));
  };

  return (
    <div className="flex flex-col gap-3">
      <label className="flex min-h-[140px] cursor-pointer items-center gap-6 rounded-lg border-2 border-dashed border-[#E0E0E0] bg-white px-12 py-8">
        <input
          type="file"
          multiple
          accept={ACCEPT}
          className="hidden"
          onChange={(event) => handleFiles(event.target.files)}
        />
        <Svg Icon={UploadIcon} className="h-12 w-12 text-red" />
        <span className="flex flex-col gap-1">
          <span className="text-base font-semibold">Upload your files</span>
          <span className="text-sm text-grey-secondary">Maximum File Size is 20MB</span>
          <span className="text-sm text-grey-secondary">Supported File Types are .png, .jpeg, .pdf, .csv</span>
        </span>
      </label>

      {files.map((file, index) => (
        <div
          key={`${file.name}-${file.size}-${file.lastModified}`}
          className="flex h-[72px] items-center justify-between rounded-lg bg-[#F6F6F6] px-5"
        >
          <div className="flex min-w-0 items-center gap-4">
            <Svg Icon={PdfIcon} className="h-9 w-9 shrink-0" />
            <span className="truncate text-lg font-medium">{file.name}</span>
          </div>
          <button
            type="button"
            aria-label={`Remove ${file.name}`}
            className="shrink-0 cursor-pointer p-2"
            onClick={() => onChange(files.filter((_, fileIndex) => fileIndex !== index))}
          >
            <Svg Icon={CloseIcon} className="h-5 w-5 stroke-red" />
          </button>
        </div>
      ))}
    </div>
  );
};
